module.exports = __webpack_public_path__ + "files/a4a388b38b32678e83823ef1b3e17766.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/mattermost.png
// module id = 732
// module chunks = 60